const reportVersions = {
    "1_0": "1.0",
    "2_0": "2.0",
};

export default reportVersions;
